import FormattedMessage from 'I18n/components/FormattedMessage';
import { PASS } from '../../filterQueryFormat/MatchStatus';
import { useMemo } from 'react';
import SinglePanelMatchStatusIcon from './SinglePanelMatchStatusIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerTestFiltersMembershipMatchDisplay = props => {
  const {
    matchStatus,
    objectName
  } = props;
  const StatusMessage = useMemo(() => {
    if (matchStatus === PASS) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.testFiltersMembership.passes",
        options: {
          objectType: objectName
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.testFiltersMembership.fails",
      options: {
        objectType: objectName
      }
    });
  }, [matchStatus, objectName]);
  return /*#__PURE__*/_jsxs(Flex, {
    marginBlockStart: "100",
    alignItems: "center",
    as: "div",
    children: [/*#__PURE__*/_jsx(SinglePanelMatchStatusIcon, {
      matchStatus: matchStatus
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      children: StatusMessage
    })]
  });
};
export default ViewerTestFiltersMembershipMatchDisplay;